import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, IconButton, SxProps, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import React from 'react';
import warningIcon from '../../../../../assets/images/triangle-exclamation.png';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { sxButton, sxButtons, sxCloseIconButton, sxModal, sxTextButton, sxTypographySubTitle, sxTypographyTitle } from './sxProps';

interface Props {
    showModal: boolean;
    handleCancelarClick: () => void;
    handleDesistirClick: () => void;
}

const DesistirModal: React.FC<Props> = ({
  showModal, handleCancelarClick, handleDesistirClick
}) => {

  const accessibility = useAccessibility();

  return (
    <div>
      <Modal
        open={showModal}
      >
        <Box sx={sxModal} style={{...accessibility.textStyleAccessibility, ...accessibility.contrastBorderAccessibility}}>
          <IconButton
              aria-label="close"
              onClick={handleCancelarClick}
              sx={sxCloseIconButton}
            >
              <FontAwesomeIcon icon={faTimes} size="1x" color='black' style={accessibility.textStyleAccessibility} />
            </IconButton>
            <div className='modal-feedback-icon-holder'>
              <img src={warningIcon} alt={"Icone de confirmacao."} className='container-modal-feedback-image'/>
            </div>
            <Typography sx={sxTypographyTitle}>Atenção</Typography>
            <Typography sx={sxTypographySubTitle}>Você vai perder todo o progresso da autoavaliação atual. Deseja desistir da autoavaliação?</Typography>
            <Box sx={sxButtons}>
              <Button
                style={accessibility.buttonStyleAccessibility}
                onClick={handleCancelarClick}
                sx={sxButton}
                variant='outlined'
              >
                <Typography style={accessibility.buttonTextStyleAccessibility} sx={sxTextButton}>Cancelar</Typography>
              </Button>
              <Button
                onClick={handleDesistirClick}
                sx={{ ...sxButton, backgroundColor: '#D84141', border: '#D84141' }}
                variant='contained'
              >
                <Typography style={accessibility.buttonTextStyleAccessibility} sx={sxTextButton}>Desistir</Typography>
              </Button>
            </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default DesistirModal;
